// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"55d909e4","242":"aad50300","284":"e21ecdd4","318":"66b59bbf","687":"f28648c8","833":"8a5085d5"}[chunkId] + ".chunk.js";
};